// extracted by mini-css-extract-plugin
export var compactFilters = "_bs-4";
export var detailImage = "_bs-1";
export var dropdownContainer = "_bs-2";
export var imageContainer = "_bs-0";
export var selectedCard = "_bs-3";